
import React, {
  useState,
  useEffect,
  useRef,
  Component,
  useCallback,
} from "react";
import cn from "classnames";
import Button from "@material-ui/core/Button";
import { getRequest } from "services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";

import ReactTooltip from "react-tooltip";
import GoogleMapMarker from "components/googlemap/GoogleMapMakerTracking";
import styles from "./BatteryTrackingComponent.module.scss";
import Geocode from "react-geocode";
import Table from "components/common/Table";
import styled from "styled-components";
import moment from "moment";
const Styles = styled.div`
table{
  th,
    td {
      border-bottom: 1px solid #f5f5ff;
      border-right: 0px solid black;
      padding: 8px;
      white-space: nowrap;
      text-align: start;

      :last-child {
        border-right: 0;
        text-align: left;
        
      }
    }
}

`


export default function BatteryTracking(props) {
  const filterInitialValue = {
    startDate: parseInt(Date.now() / 1000) - 86400,
    endDate: parseInt(Date.now() / 1000),
    siteId: "",
    chargerId: "",
    state: "",
    city: "",
    zoneId: "",
  };
  const [Coords, setCoords] = useState([]);
  const [data, setData] = useState([]);
  const [loading,setLoading]=useState(false);
  const [totalMiles, setTotalMiles] = useState(0);
  const [totalHours, setTotalHours] = useState(0);
  const [totalMin, setTotalMin] = useState(0);

  const columns = React.useMemo(() => [
    {
      Header: "Total No.",
      accessor: "totalNo",
    },
    {
      Header: "Battery Serial No.",
      accessor: "batterySerialNumber",
    },
    {
      Header: "Address",
      accessor: "address",
      Cell: (row) => {
        return (
          <>
            <div data-for="main" data-tip={row.row.original.address}>
              {row.row.original.address.length>30?row.row.original.address.slice(0,30)+"...":row.row.original.address}
            </div>
            <ReactTooltip id="main" type="light" />
          </>
        );
      },
    },
    {
      Header: "Start Time",
      accessor: "startTime",
    },
    {
      Header: "End Time",
      accessor: "endtime",
    },
    {
      Header: "Miles",
      accessor: "miles",
    },
    {
      Header: "Duration",
      accessor: "duration",
    },

    // {
    //   Header: "End Time",
    //   accessor: "status",
    //   Cell: (props) => {
    //     return (
    //       <>
    //         <button  className={cn(styles.but_Active, styles.but_Color_white, styles.but, styles.pd10)}>Active</button>
    //       </>
    //     );
    //   },
    // },
  ]);

  //Address

  /*var Coords = [

    {
      "lat": 28.595650,
      "lng": 77.343940,
      "time": "2022-06-22 06:43:42.215607"
      },
      {
        "lat":28.461448,
        "lng": 78.023107,
        "time": "2022-06-22 06:43:42.215607"
      },
      {
        "lat": 28.595650,
        "lng": 75.343940,
        "time": "2022-06-22 06:43:42.215607"
        },
        {
          "lat":29.461448,
          "lng": 78.023107,
          "time": "2022-06-22 06:43:42.215607"
        },
  
        {
          "lat":30.461448,
          "lng": 79.023107,
          "time": "2022-06-22 06:43:42.215607"
        },
        {
          "lat":31.461448,
          "lng": 80.023107,
          "time": "2022-06-22 06:43:42.215607"
        },

  ];
*/
  const markersData = Coords;
 /* var data = [
    {
      index: 1,
      address: "A-153 Link Road Greater Noida",
      startTime: "2022-08-04 13:05",
      endTime: "2022-09-04 22:05",
      miles: 20,
      duration: "1h 32min",
    },
    {
      index: 2,
      address: "A-153 Link Road Greater Noida",
      startTime: "2022-08-04 13:05",
      endTime: "2022-09-04 22:05",
      miles: 40,
      duration: "1h 32min",
    },
    {
      index: 3,
      address: "A-153 Link Road Greater Noida",
      startTime: "2022-08-04 13:05",
      endTime: "2022-09-04 22:05",
      miles: 25,
      duration: "1h 32min",
    },
    {
      index: 4,
      address: "A-153 Link Road Greater Noida",
      startTime: "2022-08-04 13:05",
      endTime: "2022-09-04 22:05",
      miles: 10,
      duration: "1h 32min",
    },
  ];
  */
  const [userRole, setUserRole] = useState("");

  const getBatteryTrackData = useCallback(async () => {
    var arr1 = [];
    var arr2 = [];

    await getRequest("track?batterySerialNumber=" + props.batterySerial)
      .then((res) => {
        if (res && res?.data && res?.data?.length >= 1) {
          var i=1;
          res?.data.map((item) => {
            var address = '';
            Geocode.fromLatLng(item.latitude, item.longitude,'AIzaSyAWSfp11ay0zsj1xJ5aiNwZcZgz73CHTvs').then(
              (response) => {
                address = response.results[0].formatted_address;
                console.log("vikas address", address);
              },
              (error) => {
                console.log('irfan');
                console.error(error);
              }
            );
            var var1 = {
              totalNo: i,
              address: address,
              startTime: moment(item.startTime).format('DD-MM-YYYY HH:mm:ss'),
              endtime: moment(item.endtime).format('DD-MM-YYYY HH:mm:ss'),
              miles: item.miles,
              duration: moment((item.endtime)-(item.startTime)).format('HH:mm:ss'),
            };
            var var2 = {
              latitude: item.latitude,
              longitude: item.longitude,
              miles: item.miles
            }
            i++;
            arr1.push(var1);
            arr2.push(var2);
          });
          // setData(arr1);
          // setCoords(arr2);
          console.log('coords',Coords);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  const addressData = async (latitude,longitude)=>{
    return await Geocode.fromLatLng(latitude , longitude,process.env.REACT_APP_GOOGLE_API_KEY).then(
     (response) => {
       return response.results[0].formatted_address;
     },
     (error) => {
       console.error(error);
       return ""
     }
   );
 
 }
  const trackingData = useCallback(async () => {
    setLoading(true);
    setCoords([]);
    setData([]);
    setTotalHours(0);
    setTotalMin(0);      
    setTotalMiles(0);
    var arr1 = [];
    var arr2 = [];
    var response;
     await getRequest("track?batterySerialNumber=" + props.batterySerial)
      .then((res) => {
        if (res && res?.data && res?.data?.length >= 1) {
          response=res.data;   
        }
      })
      .catch((err) => {
        console.error("Error", err);
        setCoords([]);
        setData([]);
        setLoading(true);
      });
      var i=1;
      var milesTotal=0;
      var hoursTotal=0;
      var minTotal=0;
      let durationOne = moment.duration(0, 'months');
      if(response){
      response.reverse();
      for (const item of response) {
        if(item.latitude && item.longitude){
        var address=await addressData(item.latitude,item.longitude);
        var duration="-";
        if(!(item.startTime===null || item.startTime===undefined || item.endtime===null || item.endtime===undefined)){
          var ms = moment(item.endtime).diff(moment(item.startTime*1000));
          var d = moment.duration(ms);
          durationOne.add(d);
          duration =
                (parseInt(d.asHours())>0?(parseInt(d.asHours())+"h "):"")+
                ((parseInt(d.asMinutes()) % 60)>0?((parseInt(d.asMinutes()) % 60)+"min"):"");
          }
          if(duration==='')
            duration="-"
            if(item.miles){
              item.miles=parseFloat(item.miles).toFixed(1);
              milesTotal=milesTotal+parseFloat(item.miles);
            }
        var var1 = {
          totalNo: i,
          batterySerialNumber : item.batterySerialNumber,
          address: address,
          startTime: item.startTime?moment(item.startTime*1000).format('DD-MM-YYYY HH:mm:ss'):"-",
          endtime: item.endtime?moment(item.endtime).format('DD-MM-YYYY HH:mm:ss'):"-",
          miles: item.miles?item.miles:"-",
          duration: duration,
        };
        var var2 = {
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
          id: i
        }
        i++;
        arr2.push(var2);
        arr1.push(var1);
      }
      }
    hoursTotal=hoursTotal+parseInt(durationOne.asHours());
    minTotal=minTotal+((parseInt(durationOne.asMinutes()) % 60));
    setTotalHours(hoursTotal);
    setTotalMin(minTotal);      
    setTotalMiles((Number(milesTotal) === milesTotal && milesTotal % 1 === 0)?milesTotal:milesTotal.toFixed(1));
    setCoords(arr2);
    setData(arr1);    
  }
  setLoading(false);
  });
  useEffect(() => {
    trackingData();
  }, []);
  Geocode.setApiKey({ key: process.env.REACT_APP_GOOGLE_API_KEY });

  // bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
  const getBattery = useCallback(async () => {
    console.log("dddddz");
    Geocode.fromLatLng("48.8583701", "2.2922926").then(
      (response) => {
        const address = response.results[0].formatted_address;
        console.log("vikas address newm", address);
      },
      (error) => {
        console.log('irfan');
        console.error(error);
      }
    );
  });

  return (
    <>
      <h2 className={cn(styles.medium_title, styles.medium_title_layout)}></h2>

      <div
        className={cn(styles.card_list_block, styles.card_list_block_layout)}
      >
        <div className={cn(styles.upper_graph_flex_spacer)} />
        <div className={cn(styles.map_card)}>
          <div
            className={cn(
              styles.status_block_map,
              styles.status_block_layout_map,
              styles.mg20,
              styles.pd20
            )}
          >
            <div className={cn(styles.flex2, styles.flex2_layout)}>
            {!loading && <GoogleMapMarker
          chartData={Coords}
          // Coords={Coords}
          />}  
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          borderRadius: "7px",
          backgroundColor: "#fff",
          marginTop: "20px",
          "box-shadow": "rgb(35 41 122 / 25%) 0px 3px 8px 2px",
        }}
      >
        <div className={cn(styles.flex2, styles.flex2_layout, styles.pdt20)}>
          <div className={cn(styles.flex2_item)}>
            <div className={cn(styles.block1, styles.block1_layout)}>
              <img
                src={require("assets/batteryTrackingIcon.svg").default}
                alt="Rectangle 16663"
                className={cn(styles.box1, styles.box1_layout)}
              />
            </div>
          </div>

          <div className={cn(styles.flex2_spacer)} />
          <div className={cn(styles.flex2_item1)}>
            <div className={cn(styles.block2, styles.block2_layout)}>
              {/* <h3 className={cn(styles.small_title, styles.small_title, styles.small_title_bold )}> */}
              <h2
                className={cn(styles.medium_title, styles.medium_title_layout)}
              >
                <p> {"Battery Live Tracking"}</p>
                <p>{totalHours}HR {totalMin}MIN</p>
              </h2>
              <p>{totalMiles} Miles</p>
            </div>
          </div>
        </div>

        {/* <div className={cn(styles.flex2, styles.flex2_layout)}> */}
        <div className={cn(styles.block25, styles.block25_layout)}> 
        <Styles>
          <Table columns={columns} data={data} />
          </Styles>
        </div>
          
          {/* <TableAndSearch columns = {columns} data = {Coords}/> */}
        {/* </div> */}
      </div>
    </>
  );
}
